export default "__VITE_ASSET__D0wyL5py__"